<template>
  <router-view></router-view>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css';
export default {
  name: 'app'
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
@import url('https://fonts.googleapis.com/css?family=Lato:400,700&display=swap');
@import url('https://fonts.googleapis.com/css?family=Merriweather:700&display=swap');

$color--primary: #F76352;
$color--primary-alt: #340068;
$color--light-gray: #DDE2EF;
$color--off-white: #EAE2D8;
$color--off-white-alt: #F1F1F1;
$color--mid-gray: #6D6E71;
$color--body: #3F3F4D;
$color--accent: #D7215E;

@keyframes fadeInDown {
	from {
		opacity:0;
		transform:translate3d(0,-25px,0);
	}
	to {
		opacity:1;
		transform: none;
	}
}

[class*=cascade-] {
	animation-name: fadeInDown;
    animation-timing-function: cubic-bezier(.165,.84,.44,1);
    animation-fill-mode: both;
    animation-duration: 0.5s;
    animation-delay: 0.5s;
}

.cascade-1 {
    animation-delay: 0.5s;
}

.cascade-2 {
	animation-delay: 0.8s;
}

.cascade-3 {
    animation-delay: 1.1s;
}

$font--body: "Lato", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
$font--heading: "Merriweather", serif;

html, body {
    font-family: $font--body;
	font-size: 15px;
    letter-spacing: 0.01rem;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    overflow-y: auto;
    min-height: 100%;
}

.h1, h1, .h2, h2, .h3, h3, .h4, h4, .h5, h5 {
	font-family: $font--heading;
	color: $color--primary-alt;
}

.h1, h1 {
	font-size: 2rem;
}

.h2, h2 {
	font-size: 1.5rem;
}

.h3, h3 {
	font-size: 1.17rem;
}

.h4, h4 {
	font-size: 1rem;
}

.h5, h5 {
	font-size: 0.83rem;
}

.h6, h6 {
	font-size: 0.67rem;
}

input, button, .btn {
	font-size: inherit;
	font-family: inherit;
}

html, body {
	height: 100% !important;
	color: $color--body;
}

.material-icons {
	vertical-align: middle;
	font-size: inherit;
}

a, a:focus, a:hover {
	color: $color--primary;
	transition: linear 0.2s;
}

.btn {
	font-weight: 500;
}

.btn-primary {
	background: $color--primary;
	border-color: $color--primary;

	&:hover, &:focus, &:active {
		background: $color--primary-alt !important;
		border-color: $color--primary-alt !important;
	}
}

.btn-link {
	color: $color--primary;
}

.text-primary {
	color: $color--primary !important;
}

.font-weight-bold {
	font-weight: 500 !important;
}

.jumbotron {
	background: $color--body;
	color: white;
}

.bg-light {
	background-color: $color--off-white;
}

.navbar {
	height: 80px;
	@media (max-width: 768px) {
		height: auto;
		padding: 1rem
	}
}
.navbar-brand {
	img {
		width: 200px;
		display: block;
	}
}

.logo {
	margin-top: 1.5rem;

	img {
		width: 175px;
	}
}

.home {
	background-image: linear-gradient(white, #FAFAFA);
	.display-1 {
		font-family: $font--heading;
		font-size: 4rem;
		color: $color--primary-alt;
	}
	.mb-5 {
		margin-bottom: 6% !important;
	}
	.content {
		position: relative;
		margin-top: 10%;
		.interior {
			position: relative;
			z-index: 1;
		}
		&:after {
			content: "";
			display: block;
			position: absolute;
			top: 50%;
			right: 0;
			width: 700px;
			height: 700px;
			transform: translateY(-50%);
			background: url(./assets/images/bg-home.svg) 100% center no-repeat;
			background-size: 700px;
			z-index: 0;
			@media (max-width: 768px) {
				top: 35%;
				background-size: 300px;
			}
		}
	}
	.home-search {
		max-width: 750px;
		position: relative;
		z-index: 10;
		input {
			display: block;
			border: 2px solid $color--light-gray;
			padding: 0.75rem 1rem;
		}
		button {
			padding: 0.75rem 1rem;
		}
	}

	.home-footer {
		bottom: 1.5rem;
		left: 0;
	}
}

.jrp {
	@media (max-width: 768px) {
		.navbar-brand img {
			margin-left: -15px;
		}
	}
	.container {
		max-width: 1200px;
	}
	.search-form {
		width: 100%;
		max-width: 650px;
		input {
			border: 2px solid $color--light-gray;
			padding: 0.5rem 0.75rem;
		}
		button {
			padding: 0.5rem 0.75rem;
		}
		@media (max-width: 768px) {
			width: 100%;
			margin-left: 0 !important;
			margin-top: 1rem;
			&.ml-auto {
				margin-left: 0 !important;
			}
			input, button {
				padding: 5px;
			}
			.pl-0 {
				padding-right: 5px;
			}
		}
	}

	.results {
		.job {
			a {
				display: block;
				border-radius: 3px;
				padding: 2rem 0;
				color: inherit;
				&:hover {
					text-decoration: none;
					.title {
						text-decoration: underline;
					}
				}
			}
			.h3 {
				font-family: $font--heading;
				font-size: 1.3rem;
				color: $color--primary-alt;
			}
			.meta {
				color: $color--mid-gray;
				li:not(:last-of-type) {
					margin-right: 1rem;
				}
				i {
					margin-top: -1px;
				}
			}
			.badge {
				background: $color--accent;
				position: absolute;
				top: 0.5rem;
				right: 0.5rem;
				font-weight: normal;
			}
		}
	}

	h5 {
		font-family: $font--heading;
		font-size: 1.2rem;
	}

	select {
		background: white;
		padding: 0.5rem 0.75rem;
		border: 2px solid $color--light-gray;
		height: 38px;
	}

	.pagination {
		a {
			color: $color--primary;
		}
		.page-item.active .page-link {
			background-color: $color--primary;
			border-color: $color--primary;
		}
		.page-link:hover {
			background-color: $color--light-gray;
		}
	}
}

@media (min-width: 768px) {
	#filter-widget {
		display: block;
		height: auto !important;
		visibility: visible;
	}
}

@media (max-width: 768px) {
	#filter-widget .jumbotron {
		height: auto !important;
	}
	html, body {
		font-size: 12px;
	}
}

</style>
